import { TranslationMessages } from '../types';
import { app } from './app/de-AT';
import { settingsApp } from './app/de-AT';

const de_AT: TranslationMessages = {
  nav: {
    howItWorks: 'So funktioniert\'s',
    why: 'Warum?',
    features: 'Funktionen',
    getStarted: 'JETZT STARTEN',
    dashboard: 'Dashboard',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Einfach bezahlt werden',
    subtitle: 'Erstellen Sie sofort Zahlungslinks, verwalten Sie Ihr Guthaben und ziehen Sie in TON ab. 3 % Plattformgebühr.',
    cta: 'Jetzt starten',
    hairsim: 'Simulieren Sie Ihre Haartransplantation',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Zahlungslink erstellt.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Monatliches Abonnement',
    stars: 'Stars',
    payBtn: '100 Stars bezahlen',
    iPayNow: 'Ich zahle jetzt',
    paymentLabel: 'Telegram Stars Zahlung',
    merchant: 'Händler',
    amount: 'Betrag',
    confirmPay: 'Zahlung bestätigen',
    paymentReceived: 'Zahlung erhalten — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · dem Guthaben gutgeschrieben',
    thanks: 'Danke, Zugang aktiviert',
    messagePlaceholder: 'Nachricht',
  },
  stats: {
    title: 'Vertraut von Tausenden von Agenten',
    subtitle: 'Werden Sie Teil einer wachsenden Community von Händlern, die Telegram Stars Zahlungen nutzen',
    activeAgents: 'Aktive Agenten',
    transactions: 'Transaktionen',
    uptime: 'Verfügbarkeit',
    support: 'Support',
  },
  features: {
    title: 'Alles, was Sie für Telegram Stars Zahlungen brauchen',
    subtitle: 'Eine vollständige Plattform zur Verwaltung Ihrer Telegram Stars Zahlungen',
    instantTitle: 'Sofortige Erstellung',
    instantDesc: 'Werden Sie in Sekunden Agent. Keine Konfiguration erforderlich.',
    balanceTitle: 'Guthabenverwaltung',
    balanceDesc: 'Verfolgen Sie Ihre Einnahmen in Echtzeit mit einem intuitiven Dashboard.',
    paymentsTitle: 'Telegram Stars Zahlungen',
    paymentsDesc: 'Akzeptieren Sie Zahlungen in Telegram Stars über Ihren Bot.',
    securityTitle: 'Maximale Sicherheit',
    securityDesc: 'Unveränderliches Ledger, sichere und transparente Transaktionen.',
    withdrawTitle: 'TON-Auszahlungen',
    withdrawDesc: 'Ziehen Sie Ihr Guthaben direkt auf Ihre TON-Adresse ab.',
    apiTitle: 'Robuste API',
    apiDesc: 'Einfache Integration mit Webhooks und einer vollständigen REST-API.',
  },
  how: {
    title: 'So funktioniert\'s',
    subtitle: 'In 3 einfachen Schritten starten',
    startDemo: 'Demo starten',
    demoRunning: 'Demo läuft...',
    reset: 'Zurücksetzen',
    step1Title: '1. Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    noCard: '✓ Keine Kreditkarte erforderlich',
    step2Title: '2. Zahlungslinks erstellen',
    amountStars: 'Betrag (Stars)',
    generatedLink: 'Generierter Link:',
    shareLink: '✓ Teilen Sie diesen Link mit Ihren Kunden',
    step3Title: '3. Guthaben abheben',
    tonAddress: 'TON-Adresse',
    availableBalance: 'Verfügbares Guthaben:',
    fee: 'Gebühr: 3 %',
  },
  pricing: {
    title: 'Einfache und transparente Preise',
    subtitle: 'Keine versteckten Gebühren, keine Bindung',
    commission: 'Provision',
    perTransaction: 'pro Transaktion',
    freeAccount: 'Kostenlose Kontoerstellung',
    noMonthly: 'Keine monatlichen Gebühren',
    tonWithdrawals: 'Integrierte TON-Auszahlungen',
    completeDashboard: 'Vollständiges Dashboard',
    support247: '24/7 Support',
    startNow: 'Jetzt starten',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    subtitle: 'Alles, was Sie über Telegram Stars Zahlungen wissen müssen',
    q1: 'Wie funktioniert die Telegram Stars Zahlung?',
    a1: 'Die Telegram Stars Zahlung ermöglicht es Händlern, Zahlungen direkt über Telegram zu akzeptieren. Nutzer erstellen Zahlungslinks, teilen sie mit Kunden und erhalten Zahlungen in der Telegram Stars Währung.',
    q2: 'Wie hoch ist die Plattformgebühr?',
    a2: 'Die Plattformgebühr beträgt 3 % pro Transaktion. Dies deckt die Zahlungsabwicklung, Ledger-Verwaltung und Plattformwartung ab. Es gibt keine Einrichtungsgebühren oder monatlichen Kosten.',
    q3: 'Wie ziehe ich meine Telegram Stars ab?',
    a3: 'Sie können Auszahlungen auf Ihre TON-Wallet anfordern. Auszahlungen werden aus Sicherheitsgründen manuell bearbeitet. Die Mindestauszahlung beträgt 100 Stars.',
    q4: 'Ist die Telegram Stars Zahlung sicher?',
    a4: 'Ja, alle Zahlungen werden über das sichere Zahlungssystem von Telegram abgewickelt. Wir verwenden branchenübliche Verschlüsselung und Sicherheitspraktiken.',
    q5: 'Was sind Telegram Stars?',
    a5: 'Telegram Stars ist eine virtuelle Währung innerhalb von Telegram für Zahlungen. Nutzer können Stars kaufen und damit für Dienstleistungen, Produkte und Abonnements bezahlen.',
    q6: 'Kann ich Telegram Stars Zahlungen für mein Unternehmen nutzen?',
    a6: 'Ja! Die Telegram Stars Payment Platform ist für Händler, Creator und Unternehmen konzipiert. Sie können Zahlungen für digitale Produkte, Dienstleistungen, Abonnements und mehr akzeptieren.',
  },
  cta: {
    title: 'Bereit loszulegen?',
    subtitle: 'Schließen Sie sich Tausenden von Agenten an, die unsere Plattform bereits nutzen',
    createAccount: 'Kostenloses Konto erstellen',
    signIn: 'Anmelden',
  },
  footer: {
    description: 'Vollständige SaaS-Plattform für Telegram Stars Zahlungen',
    product: 'Produkt',
    features: 'Funktionen',
    pricing: 'Preise',
    support: 'Support',
    signIn: 'Anmelden',
    docs: 'Dokumentation',
    copyright: '© 2024 Telegram Stars Payment Platform. Alle Rechte vorbehalten.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Zahlungen per Telegram Stars akzeptieren',
    description: 'Akzeptieren Sie Zahlungen per Telegram Stars. Erstellen Sie sofort Zahlungslinks, verwalten Sie Ihr Guthaben und ziehen Sie in TON ab. 3 % Plattformgebühr. Beginnen Sie noch heute, Telegram Stars Zahlungen zu akzeptieren.',
    keywords: 'telegram stars zahlung, telegram stars akzeptieren, telegram stars payment platform, telegram stars zahlungsgateway',
  },
  whyPage: {
    seoTitle: 'Warum Telegram Stars Payment Platform | Vorteile & Nutzen',
    seoDescription: 'Entdecken Sie, warum Händler und Creator die Telegram Stars Payment Platform wählen: sofortige Einrichtung, transparente Preise, sichere Zahlungen und globale Reichweite.',
    title: 'Warum uns wählen?',
    subtitle: 'Entwickelt für Händler und Creator, die einfache Telegram Stars Zahlungen wünschen',
    r1Title: 'Sofortige Einrichtung',
    r1Desc: 'Starten Sie in Sekunden. Keine komplexe Konfiguration oder technisches Wissen erforderlich.',
    r2Title: 'Transparente Preise',
    r2Desc: 'Nur 3 % pro Transaktion. Keine versteckten Gebühren, keine monatlichen Kosten, keine Einrichtungsgebühren.',
    r3Title: 'Sicher & zuverlässig',
    r3Desc: 'Aufgebaut auf der sicheren Zahlungsinfrastruktur von Telegram mit branchenüblicher Verschlüsselung.',
    r4Title: 'Globale Reichweite',
    r4Desc: 'Akzeptieren Sie Zahlungen von Telegram-Nutzern weltweit. Keine geografischen Einschränkungen.',
    r5Title: 'Einfache Integration',
    r5Desc: 'Einfache API und Webhooks. Integrieren Sie sich in Minuten in Ihre bestehenden Systeme.',
    r6Title: 'TON-Auszahlungen',
    r6Desc: 'Ziehen Sie direkt auf Ihre TON-Wallet ab. Schnelle und sichere Auszahlungen.',
  },
  howPage: {
    seoTitle: 'So funktioniert\'s | Telegram Stars Payment Platform',
    seoDescription: 'Erfahren Sie, wie Sie in 3 einfachen Schritten Zahlungen per Telegram Stars akzeptieren. Erstellen Sie Ihr Konto, generieren Sie Zahlungslinks und ziehen Sie in TON ab.',
    title: 'So funktioniert\'s',
    subtitle: 'Akzeptieren Sie Telegram Stars Zahlungen in drei einfachen Schritten',
  },
  settings: {
    title: "Einstellungen",
    languageSection: "Sprache",
    defaultLanguage: "Standardsprache",
    languageHint: "Diese Sprache gilt für die gesamte Plattform (Landingpages und Oberfläche).",
    languageSaved: "Sprache aktualisiert",
    ...settingsApp,
  },
  app,
};

export default de_AT;
